import { DocumentDetailsFragments } from 'features/pages/portfolio/DocumentLibrary/DocumentDetails.fragments';

import { gql } from '@apollo/client';

import { FullBidFields } from 'query/SellerDealsWithCarves';

const DealCarve = gql`
  fragment BidStipulationsDealCarve on DealCarve {
    id
    stipulations {
      bid_basis_points
      is_servicing_retained
      servicing_rate_bps
      transfer_amount
      has_diligence_completion_date_seconds
      diligence_completion_date_seconds
      has_settlement_date_seconds
      settlement_date_seconds
      has_percent_collateral_diligence
      percent_collateral_diligence_bps
      has_min_net_yield_to_buyer
      min_net_yield_to_buyer_bps
      custom_stipulations
    }
  }
`;

const BidStipulationFragments = {
  DealCarve,
  PlaceBidCard: gql`
    fragment BidStipulationsPlaceBidCard on PlaceBidCard {
      asset_class
      is_servicing_negotiable
      servicing_fee_rate_bps
      servicing_preference
      participation_rate
      is_participation_negotiable
      deal {
        id
        buyer {
          ... on PrivateCompany {
            id
            regulatory_agency
          }
          ... on UserCompany {
            id
            regulatory_agency
          }
        }
        seller {
          ... on PrivateCompany {
            id
            regulatory_agency
          }
          ... on UserCompany {
            id
            regulatory_agency
          }
        }
      }
      bids {
        ...FullBidFields
      }
      documents {
        id
        ...TermsDocument
      }
      carves {
        id
        ...BidStipulationsDealCarve
      }
    }
    ${DocumentDetailsFragments.termsDocument}
    ${DealCarve}
    ${FullBidFields}
  `,
};

const UPDATE_CARVE_STIPULATIONS = gql`
  mutation UpdateCarveStipulation(
    $carveId: ID!
    $fieldName: StipulationFieldName!
    $value: String
    $offeringId: ID!
    $buyerCompanyId: ID!
  ) {
    updateCarveStipulation(
      input: {
        carve_id: $carveId
        field_name: $fieldName
        value: $value
        offering_id: $offeringId
        buyer_company_id: $buyerCompanyId
      }
    ) {
      id
      ...BidStipulationsDealCarve
    }
  }
  ${DealCarve}
`;

const TOGGLE_CARVE_STIPULATION = gql`
  mutation ToggleCarveStipulation(
    $carveId: ID!
    $fieldName: StipulationToggleName!
    $value: Boolean!
    $offeringId: ID!
    $buyerCompanyId: ID!
  ) {
    toggleCarveStipulation(
      input: {
        carve_id: $carveId
        field_name: $fieldName
        value: $value
        offering_id: $offeringId
        buyer_company_id: $buyerCompanyId
      }
    ) {
      id
      ...BidStipulationsDealCarve
    }
  }
  ${DealCarve}
`;

const UPDATE_CUSTOM_STIPULATIONS = gql`
  mutation UpdateCustomStipulations(
    $carveId: ID!
    $customStipulations: [String!]!
    $offeringId: ID!
    $buyerCompanyId: ID!
  ) {
    updateCustomStipulations(
      input: {
        carve_id: $carveId
        custom_stipulations: $customStipulations
        offering_id: $offeringId
        buyer_company_id: $buyerCompanyId
      }
    ) {
      id
      ...BidStipulationsDealCarve
    }
  }
  ${DealCarve}
`;

export default BidStipulationFragments;
export { TOGGLE_CARVE_STIPULATION, UPDATE_CARVE_STIPULATIONS, UPDATE_CUSTOM_STIPULATIONS };
